export default __webpack_public_path__ + "8f8370297504faf45b09cad61389e40f.svg";